<template>
  <layout
    :titlePage="`Transferir por ${title}`"
    :route="{ name: 'carteira-escolher-conta' }"
  >
    <SubmenuBack v-if="hasToShowNewMenu" />
    <section class="pix-register-account">
      <div
        class="columns columns--full is-vcentered pix-register-account--margin-top-0"
      >
        <div
          class="column is-two-fifths pix-register-account--header-custom pix-register-account--header"
        >
          <base-header-page
            class="c-base-header-page--full pix-register-account__header-page"
          >
            <base-icon name="pix" width="160px" height="40px" />
          </base-header-page>
        </div>
        <div class="c-base-header-page--full column">
          <div class="pix-register-account__steps-pix">
            <BaseSteps :steps="steps" :content="'pix'" />
          </div>
          <RegisterNewPixKey :pixKeyType="$route.params.pixType" />
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import SubmenuBack from '@/layouts/parts/SubmenuBack.vue'
import BaseSteps from '@/components/Wallet/BaseSteps.vue'
import BaseHeaderPage from '@/components/BaseHeaderPage.vue'
import RegisterNewPixKey from '@/components/Wallet/Pix/Register/RegisterNewPixKey.vue'

export default {
  components: {
    layout,
    SubmenuBack,
    BaseHeaderPage,
    BaseSteps,
    RegisterNewPixKey,
  },

  data() {
    return {
      title: 'chave PIX',
      typeRegister: 'Chave PIX',
      steps: [],
    }
  },

  computed: {
    walletSummary: {
      get() {
        return this.$store.state.wallet.walletSummary
      },
      set(payload) {
        this.$store.dispatch('setWalletSummary', payload)
      },
    },

    chosenOwner: {
      get() {
        return this.$store.state.wallet.chosenOwner
      },
      set(payload) {
        this.$store.dispatch('setChosenOwner', payload)
      },
    },

    hasToShowNewMenu() {
      return this.$store.state.app.wedSiteInfo.site_menu_versao ? true : false
    },
  },

  created() {
    this.walletSummary.loading ||
    (!this.walletSummary.balance && this.$route.params.user)
      ? this.$router.push({ name: 'carteira' })
      : this.tranferType(this.$route.params.transfer)
  },

  methods: {
    tranferType(transfer) {
      if (transfer === 'cc') {
        this.title = 'dados bancários'
        this.typeRegister = 'Conta bancária'
      }

      this.steps = [
        {
          step: 'Titular',
          active: true,
        },
        {
          step: this.typeRegister,
          active: true,
        },
        {
          step: 'Valor',
          active: false,
        },
        {
          step: 'Conclusão',
        },
      ]
    },
  },
}
</script>

<style lang="scss">
.pix-register-account {
  &--margin-top-0 {
    margin-top: 0;
  }

  &__header-page {
    background-color: $support;
    @media (min-width: $tablet) {
      .svg-icon {
        width: 260px;
        height: 80px;
      }
    }
  }

  &--header-custom {
    padding: 0;
    max-width: 360px;
    margin: auto;

    @media (min-width: $desktop) {
      max-width: 582px;
    }
  }
}
.margin-left-15 {
  @media (min-width: $desktop) {
    margin-left: 15px;
  }
}
</style>
